module.exports = __webpack_public_path__ + "files/bcfef498478418bd332585d78d6e1387.png";